import { relations } from 'drizzle-orm';
import { index, pgEnum, pgTable, text, uuid } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { user } from './auth.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
export const GroupType = z.enum(['DOCTOR', 'NURSE', 'PHARMACIST', 'TEHNICIAN', 'ADMIN', 'OTHER']);
export const groupTypeEnum = pgEnum('group_type', [
    GroupType.enum.DOCTOR,
    GroupType.enum.NURSE,
    GroupType.enum.PHARMACIST,
    GroupType.enum.TEHNICIAN,
    GroupType.enum.ADMIN,
    GroupType.enum.OTHER,
]);
export const groups = pgTable('group', {
    id: uuidv7('id').primaryKey(),
    name: text('name').notNull(),
    description: text('description'),
    type: groupTypeEnum('type').notNull().default(GroupType.enum.OTHER),
    ...timestamps(),
    ...userActions(),
});
export const userGroups = pgTable('user_group', {
    id: uuidv7('id').primaryKey(),
    userId: uuid('user_id')
        .notNull()
        .references(() => user.id, { onDelete: 'cascade' }),
    groupId: uuid('group_id')
        .notNull()
        .references(() => groups.id, { onDelete: 'cascade' }),
    ...timestamps(),
    ...userActions(),
}, t => [
    // every permission check reads a user's memberships
    index('idx_user_group_user').on(t.userId, t.groupId),
    // the group drawer lists its members
    index('idx_user_group_group').on(t.groupId),
]);
export const groupsRelations = relations(groups, ({ many, one }) => ({
    members: many(userGroups),
    created: one(user, { fields: [groups.createdBy], references: [user.id] }),
}));
export const userGroupsRelations = relations(userGroups, ({ one }) => ({
    user: one(user, {
        fields: [userGroups.userId],
        references: [user.id],
    }),
    group: one(groups, {
        fields: [userGroups.groupId],
        references: [groups.id],
    }),
}));
//# sourceMappingURL=groups.js.map